/**
 * @file コンポーネント：フル動画ページ機器広告問い合わせ成功モーダル ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ModalAdSuccess = (props) => {
    /**
     * 5秒後に自動でモーダルを閉じる
     */
    useEffect(() => {
        if (props.isOpenModalAdSuccess) {
            setTimeout(() => {
                props.setIsOpenModalAdSuccess(false);
            }, 5000);
        }
    }, [props.isOpenModalAdSuccess]);

    // Presenterに渡す
    return <Presenter {...props} />;
};
